
























import {Prop, Vue, Watch} from "vue-property-decorator";
import Component from "vue-class-component";
import {Widget, WidgetParameters} from "@/components/dashboard/Dashboard.vue";
import Container from "@/components/dashboard/widgets/Container.vue";
import OwnerReportRepository from "@/repositories/report/OwnerReportRepository";
import _ from "lodash";
import {PowerBiReport} from "@/modules/PowerBi";
import PowerBiFrame from "@/components/PowerBiFrame.vue";
import {Getter} from "vuex-class";

const components = {
    Container,
    PowerBiFrame,
};

interface Style {
    [property: string]: string | number;
}
interface VisualBiParameters extends WidgetParameters {
    reportId: string;
}
interface VisualBiData extends Widget {
    parameters: VisualBiParameters;
}

@Component({components})

export default class VisualBi extends Vue {
    private metadata: PowerBiReport | null = null;
    private loading: boolean = false;
    private inactive: boolean = false;

    @Prop({default: null}) public widget!: VisualBiData;
    @Getter("getOwnerReports") public ownerReports!: PowerBiReport[];


    @Watch("widget", {deep: true})
    private onWidgetChange(): void {
        this.loadReportMetadata();
    }

    protected get containerStyle(): Style {
        return {
            backgroundColor: "white",
            height: "auto",
            width: "auto",
            overflow: "hidden",
            gridArea: this.widget.area,
        };
    }

    private mounted(): void {
        this.loadReportMetadata();
    }

    public get reportUuid(): string | null {
        return _.get(this.widget.parameters, "reportUuid", null);
    }

    public loadReportMetadata(): void {
        if (!this.reportUuid) {
            this.metadata = null;
            return;
        }
        this.loading = true;
        this.inactive = false;

        const reportMatch = _.find(this.ownerReports, (report) => {
            return report.reportUuid === this.reportUuid;
        });

        if (!reportMatch) {
            this.inactive = true;
            this.loading = false;
            return;
        }

        OwnerReportRepository.get({
            filters: {uuid: reportMatch.uuid, unique: true},
            fields: ["uuid", "label", "reportUuid", "token", "enabled"]
        }).then(
            (data: any) => {
                if (data.enabled) {
                    this.metadata = data;
                } else {
                    this.inactive = true;
                }
                this.loading = false;
            },
            (err: any) => {
                this.inactive = true;
                this.loading = false;
            }
        );
    }

    public get canDisplayFrame(): boolean {
        return !!this.metadata && !!this.metadata.token && !!this.metadata.reportUuid;
    }
}
